import DetailsModal from './components/details';
import FooterPrivacy from 'src/views/auth/components/baseTemplate/FooterPrivacy';
import { getBrandByDealerNumber } from 'src/utils/helpers';
import { IUser } from 'src/utils/interfaces/user';
import { PaymentsService } from 'src/services/payments.service';
import Spinner from 'src/components/ui/spinner';
import Table from './components/table';
import TableFooter from 'src/components/table/pagination/tableFooter';
import { Tabs } from '../make/index';
import { useLocalization } from 'src/utils/useLocalization';
import Notification, {
    NotificationType,
} from 'src/components/ui/notification/Notification';
import {
    PaymentDataSearhType,
    PaymentSource,
} from 'src/utils/enums/payment.enum';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import './styles.scss';
const NO_RESULTS = 0;

const loader = (
    <div className='loader_container'>
        <Spinner />
    </div>
);
const PendingComponent = () => {
    const dispatch = useDispatch();
    const currentDealers = useSelector((state: IUser) => {
        return state.currentDealers;
    });
    const dealerDataInfo = useSelector((state: IUser) => {
        return state.dealerDataInfo;
    });
    const [content, setContent] = useState({
        payments: [],
        payoff: [],
    });
    const [brand, setBrand] = useState<string>('vw6');
    const [dealerID, setDealerID] = useState('');
    const [displayedContent, setDisplayedContent] = useState<any>([]);
    const [accountSelected, setAccountSelected] = useState<null | {}>(null);
    const [paymentSelected, setPaymentSelected] = useState<null | {}>(null);
    const [openModal, setOpenModal] = useState(false);
    const [loadingModal, setLodaingModal] = useState(false);
    const [isError, setIsError] = useState(false);
    const [showNotify, setShowNotify] = useState(false);
    useEffect(() => {
        if (currentDealers && dealerDataInfo) {
            const { dealer } = dealerDataInfo;
            setBrand(getBrandByDealerNumber(dealer.brand, dealer.dealerNumber));
            setDealerID(dealer.dealerNumber);
        }
    }, [dealerDataInfo]);
    const [loading, setLoading] = useState<boolean>(true);
    const { labelText, payments, labelField } = useLocalization();
    const [tab, setTab] = useState(Tabs.PAYMENT);
    const [errorNotification, setErrorNotification] = useState('');
    useEffect(() => {
        getContent();
    }, []);
    async function getContent(notification?: {
        show: boolean;
        type: 'ERROR' | 'SUCCESS';
        message: string;
    }) {
        if (notification) {
            setErrorNotification(notification.message);
            setIsError(notification.type === 'ERROR' ? true : false);
            setShowNotify(notification.show);
        } else {
            setErrorNotification('');
            setIsError(false);
            setShowNotify(false);
        }
        try {
            if (currentDealers && dealerDataInfo) {
                const { dealer } = dealerDataInfo;
                setLoading(true);
                const service = new PaymentsService();
                const res = await service.paymentPedings(dealer.dealerNumber);
                if (res && res.data) setContent(res.data);
                setLoading(false);
            }
        } catch (error: any) {
            const error500 = error.message.includes('500');
            setErrorNotification(
                error.message.includes('500')
                    ? labelField.LABEL_FIELD_ERROR_REQUEST_SERVICE
                    : '',
            );
            setIsError(error500);
            setShowNotify(error500);
            setLoading(false);
        }
    }
    async function getDetails(account: string) {
        try {
            if (account && currentDealers && dealerDataInfo) {
                setOpenModal(true);
                setLodaingModal(true);
                const { dealer } = dealerDataInfo;
                const service = new PaymentsService();
                const paymentSource =
                    tab == Tabs.PAYMENT
                        ? PaymentSource.Payment
                        : PaymentSource.Payoff;
                const res = await service.paymentData(
                    dealer.dealerNumber,
                    PaymentDataSearhType.Account,
                    account,
                    paymentSource,
                    dealer.brand,
                    dealer.dealerName,
                    dealerDataInfo.dealer.ccNumbers[0].toString(),
                );
                if (res && res.data) {
                    dispatch({
                        type: 'PaymentData',
                        payload: {
                            paymentData: res.data,
                        },
                    });
                    setPaymentSelected(res.data);
                    setLodaingModal(false);
                }
            }
        } catch (error: any) {
            const errorTypes = ['404', '500'];
            const errorMessage = errorTypes.some((errorType) =>
                error.mesage.includes(errorType),
            );
            setErrorNotification(
                error.message.includes('500')
                    ? labelField.LABEL_FIELD_ERROR_REQUEST_SERVICE
                    : error.message.includes('404')
                    ? labelText.LABEL_TEXT_FUNDING_SEARCH_ERROR_NO_RESULTS
                    : '',
            );
            setIsError(errorMessage);
            setShowNotify(errorMessage);
            setLodaingModal(false);
            setOpenModal(false);
        }
    }
    return !!dealerID ? (
        <>
            <div className='payment-status-wrapper'>
                {showNotify && (
                    <Notification
                        content={errorNotification}
                        type={
                            isError
                                ? NotificationType.ERROR
                                : NotificationType.SUCCESS
                        }
                        visibility={showNotify}
                        setVisibility={setIsError}
                    />
                )}
                <div className='page-title'>
                    <h5>{payments.PAYMENT_INFORMATION_TABLE_TITLE}</h5>
                </div>
                <div className={'content-container'}>
                    {!loading ? (
                        <>
                            <div className='wrapper'>
                                <div className='c-tabs'>
                                    <div className='c-tabs__nav-container'>
                                        <nav aria-label='Tabs Navigation'>
                                            <div className='c-tabs__nav'>
                                                <div className='c-tabs__nav-item'>
                                                    <button
                                                        className={`c-tabs__nav-link ${
                                                            tab == Tabs.PAYMENT
                                                                ? 'is-active'
                                                                : ''
                                                        }`}
                                                        onClick={() => {
                                                            setTab(
                                                                Tabs.PAYMENT,
                                                            );
                                                        }}
                                                        type='button'
                                                    >
                                                        <a
                                                            className='c-link'
                                                            data-testid='link-item-faqs'
                                                        >
                                                            <span className='c-link__body'>
                                                                {
                                                                    payments.PAYMENT_INFORMATION_TAB_PAYMENT
                                                                }
                                                            </span>
                                                        </a>
                                                    </button>
                                                </div>
                                                <div className='c-tabs__nav-item'>
                                                    <button
                                                        className={`c-tabs__nav-link ${
                                                            tab == Tabs.PAYOFF
                                                                ? 'is-active'
                                                                : ''
                                                        }`}
                                                        onClick={() => {
                                                            setTab(Tabs.PAYOFF);
                                                        }}
                                                        type='button'
                                                    >
                                                        <a
                                                            className='c-link'
                                                            data-testid='link-item-message-center'
                                                        >
                                                            <span className='c-link__body'>
                                                                {
                                                                    payments.PAYMENT_INFORMATION_TAB_PAYOFF
                                                                }
                                                            </span>
                                                        </a>
                                                    </button>
                                                </div>
                                            </div>
                                        </nav>
                                    </div>
                                </div>
                            </div>
                            {(
                                tab === Tabs.PAYMENT
                                    ? content.payments.length > NO_RESULTS
                                    : content.payoff.length > NO_RESULTS
                            ) ? (
                                <>
                                    <Table
                                        items={displayedContent}
                                        setDetail={(
                                            account: string,
                                            transaction: string,
                                        ) => {
                                            getDetails(account);
                                            const find = account
                                                ? tab === Tabs.PAYMENT
                                                    ? content.payments.filter(
                                                          (e) =>
                                                              (e as any)
                                                                  .PaymentTransactionId ===
                                                              transaction,
                                                      )
                                                    : content.payoff.filter(
                                                          (e) =>
                                                              (e as any)
                                                                  .PaymentTransactionId ===
                                                              transaction,
                                                      )
                                                : {};
                                            if (find) setAccountSelected(find);
                                        }}
                                    />
                                    <TableFooter
                                        brand={brand}
                                        content={
                                            tab === Tabs.PAYMENT
                                                ? content.payments
                                                : content.payoff
                                        }
                                        setDisplayedContent={
                                            setDisplayedContent
                                        }
                                    />
                                    <div className='after-table disclaimer'>
                                        <span>
                                            <strong>
                                                {
                                                    payments.PAYMENT_INFORMATION_TABLE_DISCLAIMER
                                                }
                                            </strong>
                                        </span>
                                        <br></br>
                                        <span>
                                            {
                                                payments.PAYMENT_INFORMATION_TABLE_DISCLAIMER_CONTENT
                                            }
                                        </span>
                                    </div>
                                </>
                            ) : (
                                <div className='no-content'>
                                    <div>
                                        {`${labelText.LABEL_TEXT_FUNDING_SEARCH_ERROR_NO_RESULTS} `}
                                        <span className='bold'></span>
                                    </div>
                                    <div className='small-text'>
                                        {
                                            labelText.LABEL_TEXT_FUNDING_SEARCH_ERROR_SUGGESTION
                                        }
                                    </div>
                                </div>
                            )}
                        </>
                    ) : (
                        loader
                    )}
                </div>
                <div className='privacy-footer-container '>
                    <FooterPrivacy />
                </div>
                <DetailsModal
                    payment={accountSelected}
                    account={paymentSelected}
                    open={openModal}
                    setOpen={setOpenModal}
                    loading={loadingModal}
                    reload={getContent}
                    tab={tab}
                />
            </div>
        </>
    ) : null;
};

export default PendingComponent;
